var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { LotteryBrandPriceModel } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from 'linq';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import { CurrencyClientService } from '../../../../../services/modules/currency-client.service';
import { BindingSignaler } from "aurelia-templating-resources";
import { FormatterHelper } from "../../../../../helpers/numbers-helper";
var SyndicateTickets = /** @class */ (function (_super) {
    __extends(SyndicateTickets, _super);
    function SyndicateTickets(notificationService, i18N, lotteryClientService, currencyClientService, signaler) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.currencyClientService = currencyClientService;
        _this.signaler = signaler;
        _this.jackPotRanges = [];
        _this._promiseCount = 0;
        return _this;
    }
    SyndicateTickets.prototype.getLabel = function (range) {
        return range.lotteryJackpotRangeId ? ('Range: €' + FormatterHelper.getformattedValue(Number(range.rangeFrom), navigator.language, 0) + ' - €' + FormatterHelper.getformattedValue(Number(range.rangeTo), navigator.language, 0)) : 'Any Jackpot Range';
    };
    SyndicateTickets.prototype.onShouldUpdateRateChanged = function ($event, item) {
        var _this = this;
        var isChecked = $event.detail.value;
        if (isChecked) {
            var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == item.currencyId; });
            var defaultPrice = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (s) { return s.currencyId == _this.defaultCurrencyId; });
            if (rate) {
                item.price = rate.euroRate * defaultPrice.price;
            }
        }
    };
    SyndicateTickets.prototype.addTicketPrice = function (range) {
        var currentCurrencyIds = Enumerable.from(this.pricingModel.lotteryBrandPrices).select(function (x) { return x.currencyId; });
        var currencyModel = Enumerable.from(this.currencies).firstOrDefault(function (x) { return !currentCurrencyIds.contains(x.currencyId); });
        if (!currencyModel) {
            currencyModel = null;
        }
        var model = new LotteryBrandPriceModel();
        model.currencyId = currencyModel == null ? 0 : currencyModel.currencyId;
        model.lotteryPricingModelId = this.pricingModel.lotteryPricingModelId;
        model.price = 0;
        model.decimalPointRounding = 2;
        model.countryId = null;
        if (range) {
            model.lotteryJackpotRangeId = range.lotteryJackpotRangeId;
        }
        this.pricingModel.lotteryBrandPrices.push(model);
        this.signaler.signal("reloadPrices");
    };
    SyndicateTickets.prototype.onPriceChanged = function ($event, item) {
        var _this = this;
        if (item && item.currencyId == this.defaultCurrencyId) {
            var value_1 = $event.detail.newValue;
            var count_1 = ++this._promiseCount;
            Enumerable.from(this.pricingModel.lotteryBrandPrices).where(function (x) { return x.currencyId != _this.defaultCurrencyId
                && x.shouldUpdateCurrencyRate; }).forEach(function (price) {
                var rate = _this.rates.firstOrDefault(function (x) { return x.currencyId == price.currencyId; });
                if (rate) {
                    _this.lotteryClientService.calculatePrice({
                        currencyRate: rate.euroRate,
                        roundNearest: price.decimalPointRounding,
                        price: Number(value_1)
                    }).then(function (calculatedResult) {
                        if (_this._promiseCount == count_1) {
                            price.price = calculatedResult.calculatedPrice;
                        }
                    });
                }
            });
        }
    };
    SyndicateTickets.prototype.onRoundingChanged = function ($event, item) {
        var _this = this;
        if (item && item.currencyId != this.defaultCurrencyId) {
            var rate = this.rates.firstOrDefault(function (x) { return x.currencyId == item.currencyId; });
            var defaultPriceEntry = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (lbp) { return lbp.currencyId == _this.defaultCurrencyId; });
            var count_2 = ++this._promiseCount;
            this.lotteryClientService.calculatePrice({
                currencyRate: rate.euroRate,
                roundNearest: item.decimalPointRounding,
                price: Number(defaultPriceEntry.price)
            }).then(function (calculatedResult) {
                if (_this._promiseCount == count_2) {
                    item.price = calculatedResult.calculatedPrice;
                }
            });
        }
    };
    Object.defineProperty(SyndicateTickets.prototype, "isReadonly", {
        get: function () {
            if (!this.pricingModel || !this.item || !this.item.navigationInfo)
                return true;
            return this.item.navigationInfo.brandId && this.item.navigationInfo.brandId != this.pricingModel.brandId;
        },
        enumerable: false,
        configurable: true
    });
    SyndicateTickets.prototype.onActivated = function (item) {
        var _this = this;
        this.defaultCurrencyId = this.item.navigationInfo && this.item.navigationInfo.brandId ? this.item.navigationInfo.brandDefaultCurrencyId : null;
        this.currencyClientService.getRates().then(function (rates) {
            _this.rates = Enumerable.from(rates);
        });
        if (!item.pricingModels)
            item.pricingModels = [];
        this.pricingModel = item.pricingModels[0];
        var jackpotPriceTier = Enumerable.from(item.lotteryPriceTiers).firstOrDefault(function (x) { return x.isJackpot; });
        if (jackpotPriceTier && jackpotPriceTier.lotteryJackpotRanges)
            this.jackPotRanges = Enumerable.from(jackpotPriceTier.lotteryJackpotRanges).toArray();
        //insert a null range for prices to be inserted without a range
        var any = Enumerable.from(this.jackPotRanges).any(function (x) { return x.lotteryJackpotRangeId == null; });
        if (!any)
            this.jackPotRanges.splice(0, 0, {
                lotteryJackpotRangeId: null,
                lotteryPriceTierId: -1,
                rangeFrom: 0,
                rangeTo: 0
            });
        this.currencyClientService.getCurrencies().then(function (x) {
            _this.currencies = x;
            _this.defaultCurrency = Enumerable.from(x).firstOrDefault(function (x) { return x.currencyId == _this.defaultCurrencyId; });
        });
    };
    SyndicateTickets.prototype.getPricesForRange = function (range) {
        var prices = this.pricingModel && this.pricingModel.lotteryBrandPrices ?
            Enumerable.from(this.pricingModel.lotteryBrandPrices).where(function (x) { return x.lotteryJackpotRangeId == range.lotteryJackpotRangeId; }).toArray()
            : [];
        return prices;
    };
    Object.defineProperty(SyndicateTickets.prototype, "masterTicket", {
        get: function () {
            var _this = this;
            if (this.pricingModel && this.pricingModel.lotteryBrandPrices && this.jackPotRanges) {
                var range = Enumerable.from(this.jackPotRanges).firstOrDefault(function (x) { return !x.rangeFrom && !x.rangeTo; });
                if (range) {
                    var master = Enumerable.from(this.pricingModel.lotteryBrandPrices).firstOrDefault(function (x) { return x.lotteryJackpotRangeId == range.lotteryJackpotRangeId && x.currencyId == _this.defaultCurrencyId; });
                    return master;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    SyndicateTickets.prototype.removePrice = function (item) {
        var index = this.pricingModel.lotteryBrandPrices.indexOf(item);
        this.pricingModel.lotteryBrandPrices.splice(index, 1);
        this.signaler.signal("reloadPrices");
    };
    SyndicateTickets.prototype.maxHundred = function (value) {
        if (value) {
            var numberValue = (Number.parseInt(value));
            if (numberValue > 100) {
                return "100";
            }
            if (numberValue < 0) {
                return "0";
            }
            return value;
        }
    };
    SyndicateTickets = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N,
            LotteryClientService, CurrencyClientService, BindingSignaler])
    ], SyndicateTickets);
    return SyndicateTickets;
}(ChildComponent));
export { SyndicateTickets };
